/**
 * The fixed set of furniture/household types a user can pick as an item's
 * visual when it has no photo. Keys are stable (stored on the item); labels
 * live in i18n under `furniture.<key>`. Grouped for the picker.
 */
export const FURNITURE_GROUPS = [
  {
    group: 'living',
    keys: ['sofa', 'armchair', 'ottoman', 'coffee_table', 'tv', 'tv_stand', 'bookshelf', 'speaker', 'floor_lamp', 'rug', 'plant', 'chandelier', 'wall_clock', 'curtains'],
  },
  {
    group: 'bedroom',
    keys: ['bed', 'crib', 'wardrobe', 'dresser', 'nightstand', 'vanity', 'mirror', 'bunk_bed', 'shoe_rack', 'bench'],
  },
  {
    group: 'kitchen',
    keys: ['dining_table', 'chair', 'fridge', 'freezer', 'stove', 'oven', 'microwave', 'dishwasher', 'kettle', 'coffee_machine', 'kitchenware', 'bar_stool', 'toaster', 'blender', 'stand_mixer', 'rice_cooker', 'pots', 'cutting_board', 'trash_can'],
  },
  {
    group: 'bathroom',
    keys: ['bathtub', 'toilet', 'washer', 'dryer', 'water_heater', 'sink', 'towel_rack', 'hamper'],
  },
  {
    group: 'office',
    keys: ['desk', 'office_chair', 'monitor', 'printer', 'router', 'filing_cabinet', 'desk_lamp', 'books'],
  },
  {
    group: 'utility',
    keys: ['boxes', 'suitcase', 'tools', 'ladder', 'vacuum', 'fan', 'air_conditioner', 'heater', 'bicycle', 'misc'],
  },
  {
    group: 'kids',
    keys: ['stroller', 'high_chair', 'toy_box', 'scooter'],
  },
  {
    group: 'pets',
    keys: ['pet_crate', 'cat_tree'],
  },
  {
    group: 'outdoor',
    keys: ['patio_umbrella', 'lawnmower', 'cooler', 'wheelbarrow', 'surfboard', 'skis'],
  },
  {
    group: 'special',
    keys: ['piano', 'guitar', 'artwork', 'aquarium', 'treadmill', 'grill', 'safe', 'dumbbells'],
  },
] as const;

export type FurnitureGroup = (typeof FURNITURE_GROUPS)[number]['group'];

export const FURNITURE_TYPES: string[] = FURNITURE_GROUPS.flatMap((g) => [...g.keys]);
